const normalizeIdentityText = (value) =>
  String(value || '').trim().toLowerCase();

export const leadershipDashboardLabel = (user) => {
  const identity = `${normalizeIdentityText(user?.name)} ${normalizeIdentityText(user?.email)}`;

  if (identity.includes('madhuri') || identity.includes('maduri')) return 'CEO Dashboard';
  if (identity.includes('himanshu')) return 'COO Dashboard';
  if (identity.includes('alok')) return 'MD Dashboard';
  if (identity.includes('kshitij')) return 'Chairman Dashboard';

  return 'Leadership Dashboard';
};

export const focusedDashboardLabel = ({ user, team, isSuperadmin }) => {
  if (team === 'leadership') return leadershipDashboardLabel(user);
  if (isSuperadmin) return 'Fleet Admin Dashboard';
  return 'Overview';
};
